__webpack_require__.p = "/online-cosmetic-store-react/";